import { Box, Container, Typography } from '@mui/material'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)',
        color: '#d1d5db',
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 3, lg: 4 },
        borderTop: '1px solid #334155',
      }}
    >
      <Container maxWidth="lg">
        {/* Brand Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', mb: 2 }}>
            <Typography sx={{ fontSize: '2rem' }}>🍽️</Typography>
            <Box>
              <Typography
                sx={{
                  fontWeight: 900,
                  fontSize: '1.25rem',
                  background: 'linear-gradient(135deg, #dc2626 0%, #f97316 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Zedoprato
              </Typography>
              <Typography sx={{ fontSize: '0.7rem', color: '#6b7280' }}>
                Gestão de Atendimento
              </Typography>
            </Box>
          </Box>
          <Typography sx={{ fontSize: '0.9rem', color: '#9ca3af', lineHeight: 1.6, maxWidth: '600px', mx: 'auto' }}>
            Transformando a experiência de atendimento em restaurantes com tecnologia serverless.
          </Typography>
        </Box>

        {/* Divider */}
        <Box sx={{ borderTop: '1px solid #334155', my: 4 }} />

        {/* Bottom */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: '0.875rem', color: '#6b7280' }}>
            © {currentYear} Zedoprato. Todos os direitos reservados. | Feito com ❤️ para restaurantes
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
